// Libraries
import React from 'react';
import { connect } from 'react-redux';

// Components
import {
	TeamDetailModal,
	DeletePhotoModal,
	DeleteAccountModal,
	IndividualDetailModal,
	RulesModal,
} from '~/components/general/modal/_modals';

// Constants
import {
	MODAL_TYPE_TEAM_DETAIL,
	MODAL_TYPE_USER_DETAIL,
	MODAL_TYPE_DELETE_PHOTO,
	MODAL_TYPE_DELETE_ACCOUNT,
	MODAL_TYPE_RULES,
} from '~/data/constants/modal-constants';

const MODAL_COMPONENTS = {
	[MODAL_TYPE_TEAM_DETAIL]: TeamDetailModal,
	[MODAL_TYPE_USER_DETAIL]: IndividualDetailModal,
	[MODAL_TYPE_DELETE_PHOTO]: DeletePhotoModal,
	[MODAL_TYPE_DELETE_ACCOUNT]: DeleteAccountModal,
	[MODAL_TYPE_RULES]: RulesModal,
};

/**
 * The Root Component for a Modal.
 * It injects the type of Modal into it and renders.
 *
 * @class ModalRoot
 * @extends {Component}
 */
const ModalRoot = props => {
	if (!props.modal) {
		return null;
	}
	if (!props.modal.type) {
		return null;
	}

	const ModalComponent = MODAL_COMPONENTS[props.modal.type];
	return <ModalComponent {...props} />;
};

function mapStateToProps(state) {
	return {
		modal: state.modal,
	};
}

export default connect(mapStateToProps)(ModalRoot);



// WEBPACK FOOTER //
// ./src/containers/modal-root.js